import React, { useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { ActiveDatepicker } from 'component/Search/Datepicker/types';
import { ActiveDurationLayer } from 'component/Search/Duration/types';

import { ToggleFormElementContext } from '../../__context/toggleFormElementProvider';
import { CrossValidationError } from '../../__hooks/useCrossDateValidation';

import styles from './DurationError.module.scss';

type RefType = 'departure' | 'return';

const mapRefToActiveDatepicker: Record<RefType, ActiveDatepicker> = {
    departure: ActiveDatepicker.Departure,
    return: ActiveDatepicker.Return,
};

interface DurationErrorProps {
    error: CrossValidationError;
}
const DurationError = ({ error }: DurationErrorProps) => {
    const { t } = useTranslation();

    const { setActiveDatepicker, setActiveDurationLayer } = useContext(
        ToggleFormElementContext
    );

    const onClick = useCallback(
        (e: React.MouseEvent<HTMLSpanElement | undefined>) => {
            const target = e.target as HTMLLinkElement;
            const refType = target.getAttribute('data-ref') as RefType | null;
            if (refType) {
                if (
                    error === CrossValidationError.DurationLonger ||
                    error === CrossValidationError.DurationLongerFromDatepicker
                ) {
                    setActiveDatepicker(ActiveDatepicker.Return);
                } else {
                    setActiveDatepicker(mapRefToActiveDatepicker[refType]);
                }
                setActiveDurationLayer(ActiveDurationLayer.None);
            }
        },
        [error, setActiveDatepicker, setActiveDurationLayer]
    );

    switch (error) {
        case CrossValidationError.DurationLongerFromDatepicker:
        case CrossValidationError.DurationLonger:
            return (
                <span
                    onClick={onClick}
                    className={styles.Error}
                    dangerouslySetInnerHTML={{
                        __html: t('TRANS-travel-duration-longer-travel-period'),
                    }}
                />
            );
        case CrossValidationError.MaxDurationExceeded:
            return (
                <span
                    onClick={onClick}
                    className={styles.Error}
                    dangerouslySetInnerHTML={{
                        __html: t('TRANS-travel-duration-exceeds-max-duration'),
                    }}
                />
            );
    }
    return null;
};

export default DurationError;
